import React from 'react';
const PresenterChatView = () => {
    return (
                <div id="meetingSDKChatElement" className="chat-panel" ></div>
    );
};

export default PresenterChatView;
